import { render, staticRenderFns } from "./PrintLabelButton.vue?vue&type=template&id=b20e04ea&"
import script from "./PrintLabelButton.vue?vue&type=script&lang=js&"
export * from "./PrintLabelButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports